// Tried in order against the navy header: a partner's reverse/on-dark
// variant (<subdomain>-reverse.png, most deployments don't have one yet),
// its regular logo (<subdomain>.png — every deployment, including
// FarmTRX's own web/eu/staging/mydom, has this one), then the bundled
// on-dark default if the assets bucket has neither. An M3-migration change
// previously made FarmTRX-branded subdomains skip the subdomain-hosted
// asset unconditionally, which silently stopped serving whatever's
// actually uploaded for `web`/`eu`/`staging`/`mydom` if any of those ever
// differ from the bundled default — this chain always tries the bucket
// first.
export const LOGO_STAGES = ['reverse', 'base', 'bundled']

export function nextLogoStage(stage) {
  const nextIndex = LOGO_STAGES.indexOf(stage) + 1
  return LOGO_STAGES[Math.min(nextIndex, LOGO_STAGES.length - 1)]
}
